import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Dropzone from 'react-dropzone';
import { Button } from 'reactstrap';
import cn from 'classnames';
import scrollToFirstError from 'lib/utils/scrollToFirstError';
import UploadedImagePreview from './UploadedImagePreview';
import styles from './ImagesUploader.scss';

export default class ImagesUploader extends Component {
  static propTypes = {
    images: ImmutablePropTypes.list.isRequired,
    isUploading: PropTypes.bool.isRequired,
    onUpload: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    errorVisible: PropTypes.bool.isRequired,
    backendError: PropTypes.string,
    maxImages: PropTypes.number,
    publisherLogosEnabled: PropTypes.bool
  };

  onDrop = (accepted) => {
    const imagesLeft = this.maxImages() - this.props.images.size;

    accepted.slice(0, imagesLeft)
      .forEach(file => this.props.onUpload(file));
  }

  maxImages = () => this.props.maxImages || 10;

  countErrorVisible = () => this.props.errorVisible && this.props.images.size === 0;

  componentDidUpdate() {
    if (this.countErrorVisible()) {
      scrollToFirstError();
    }
  }

  render() {
    const countErrorVisible = this.countErrorVisible();
    const maxImages = this.maxImages();
    const enoughImages = this.props.images.size >= maxImages;
    const pluralS = maxImages > 1 ? 's' : '';

    return (
      <div className={cn('ImagesUploader', countErrorVisible && 'is-invalid')}>
        {this.props.publisherLogosEnabled && <p className="font-italic">
          Any event image exactly 400px by 400px is treated as a promoter's logo
        </p>}
        {!enoughImages && <div>
          <Dropzone
            accept="image/*"
            disabled={enoughImages}
            className={styles.dropzone}
            activeClassName={styles.dropzoneActive}
            onDrop={this.onDrop}
            multiple={maxImages > 1}
          >
            {this.props.isUploading ?
              <i className="fa fa-spinner fa-pulse fa-3x fa-fw m-5"></i>
              :
              <div>
                <Button type="button" disabled={enoughImages} outline color="success">
                  {enoughImages ? 'Images limit reached' : '+ Add Image' + pluralS}
                </Button>
                <span className="mt-2">Drag & Drop</span>
                <h2>Drop file{pluralS} here</h2>
              </div>
            }
          </Dropzone>
          {maxImages > 1 && <p>jpeg/png, up to {maxImages} images</p>}
        </div>}
        <div className="ImageUplader-files mb-4">
          {countErrorVisible && <p className="text-danger">Upload at least one image</p>}
          {this.props.backendError && <p className="text-danger">{this.props.backendError}</p>}
          {this.props.images.map(image =>
            <UploadedImagePreview
              key={image.get('id')}
              fileDetails={image}
              onRemove={this.props.onRemove}
            />
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/ImagesUploader.jsx